<template>
  <div class="container-summary my-3">
    <div v-if="summaryInfo || summaryStatus === 3" class="top-menu-summary">
      <transition name="fade" mode="out-in">
        <v-row key="1" v-if="!searchOn && !isAdd" align="center" justify="start" dense style="padding: 1px 0">
          <v-col cols="auto">
            <v-menu offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn dark color="#eee" plain v-bind="attrs" v-on="on" class="btn-top">
                  <span class="material-icons-round mr-1 btn-span" translate="no">content_copy</span>
                  {{ $t('export') }}
                </v-btn>
              </template>
              <div class="container-menu-summary container-menu-export">
                <v-row align="center" justify="center" dense>
                  <v-col cols="12">
                    <v-btn dark block class="" color="#eee" plain @click="allCopy()">
                      <span class="material-icons-round mr-1 btn-span" translate="no">content_copy</span>
                      {{ 'Copy summary' }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-divider dark style="display: block"></v-divider>
                  </v-col>
                  <v-col cols="12">
                    <v-btn dark block class="" color="#eee" plain disabled>
                      <span class="material-icons-round mr-1 btn-span disabled" translate="no">upcoming</span>
                      {{ 'Github' }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn dark block class="" color="#eee" plain disabled>
                      <span class="material-icons-round mr-1 btn-span disabled" translate="no">upcoming</span>
                      {{ 'Notion' }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn dark block class="" color="#eee" plain disabled>
                      <span class="material-icons-round mr-1 btn-span disabled" translate="no">upcoming</span>
                      {{ 'Linear' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-btn dark color="#eee" plain class="btn-top" @click=";(searchOn = true), (editIndex = null)">
              <span class="material-icons-round mr-1 btn-span" translate="no">search</span>
              {{ $t('search') }}
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              dark
              color="#eee"
              plain
              class="regeneration btn-top"
              @click="openDialog('SummaryRegeneration')"
              :disabled="!isClOrganizer"
            >
              <span class="material-icons-round mr-1 btn-span" translate="no" style="color: #ffc107">auto_awesome</span>
              {{ $t('regenerate') }}
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <select-language
              :plain="true"
              :autoDetect="false"
              :isClOrganizer="isClOrganizer"
              btnName="Translate"
              btnIcon="translate"
              basicBtnName="Translate"
              basicBtnColor="#21343b"
              basicBtnFontColor="#ddd"
              basicBtnIcon="translate"
              basicBtnIconColor=""
              @language="setTranslate($event['label'])"
            ></select-language>
          </v-col>
          <v-col cols="auto" v-if="isClOrganizer">
            <v-btn dark color="#eee" plain class="btn-top" @click="changeAdd">
              <span class="material-icons-round mr-1 btn-span" translate="no">add</span>
              {{ $t('add') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row key="2" v-else-if="searchOn && !isAdd" align="center" justify="start" dense>
          <v-col cols="">
            <v-text-field
              dark
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Search"
              solo
              single-line
              dense
              hide-details
              id="summarySearchField"
            ></v-text-field>
          </v-col>
          <v-col cols="auto">
            <v-btn dark class="close" color="#eee" icon @click="searchOn = false">
              <span class="material-icons-round btn-span" translate="no">close</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row key="3" v-else-if="!searchOn && isAdd">
          <v-card class="wrap-summary-card ma-3 pa-1 pt-2" elevation="0" color="#31434f" flat dark :ripple="false">
            <v-row align="center" justify="end" dense>
              <v-col cols="12">
                <v-text-field
                  dark
                  placeholder="Title"
                  solo
                  single-line
                  dense
                  hide-details
                  ref="addTitle"
                  id="addTitle"
                  v-model="topic"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  dark
                  placeholder="Content"
                  solo
                  dense
                  hide-details
                  auto-grow
                  rows="1"
                  v-model="summary"
                  ref="addContent"
                  id="addContent"
                ></v-textarea>
              </v-col>
              <v-col cols="auto">
                <v-text-field
                  dark
                  placeholder="Time"
                  solo
                  single-line
                  dense
                  hide-details
                  ref="addTime"
                  id="addTime"
                  :value="convertSecondsToTime(seekTime)"
                  v-model="addTimestamp"
                  @keydown.enter.prevent="convertInputToTime($event.target.value)"
                  @blur="
                    $event.target.value !== ''
                      ? convertInputToTime($event.target.value)
                      : ($event.target.value = convertSecondsToTime(seekTime))
                  "
                  @keydown="isNumber($event)"
                  class="add-time mr-1"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="wrap-add-menu pr-4 mb-2" align="end">
                <v-btn dark class="" color="#eee" plain @click.stop="isAdd = false">
                  <span class="material-icons-round mr-1 btn-span" translate="no">cancel</span>
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn
                  dark
                  class="btn-save"
                  color="#eee"
                  plain
                  :loading="isCreateSummaryLoading"
                  @click.stop="createSummarySegment"
                >
                  <span class="material-icons-round mr-1 btn-span" translate="no">save</span>
                  {{ $t('save') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-row>
      </transition>
    </div>

    <!-- <div v-if="computedWsClipCnt['planType'] !== 'Plus'">
      <v-row dense no-gutters>
        <v-col cols="12" align="center" class="loading-text-big mt-3 mb-1">{{ $t('summaryUpgradePlan') }}</v-col>
      </v-row>
    </div> -->
    <!-- <div v-else-if="!summarySegments || summarySegments.length === 0"> -->
    <div v-if="!summarySegments || summarySegments.length === 0">
      <!-- Summary 서버에서 변환중일때 화면 -->
      <v-row class="mx-6" v-if="isShowLoading" dense no-gutters>
        <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
          {{ $t('summaryLoadingTitle') }}
        </v-col>
        <v-col cols="12" align="center" class="loading-text-small mb-3">
          {{ $t('summaryLoadingContent') }}
        </v-col>
      </v-row>
      <!-- Summary를 선택하지 않거나 너무 짧을 경우 화면 -->
      <v-row class="mx-6" v-else-if="isUncheckedOrTooShort" dense no-gutters>
        <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
          {{ $t('summaryUncheckedOrTooShortContent') }}
        </v-col>
      </v-row>
      <!-- Summary 변환 실패시 화면 -->
      <v-row class="mx-6" v-else-if="isShowFail" dense no-gutters>
        <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
          {{ $t('error') }}
        </v-col>
      </v-row>
      <div v-else>
        <!-- Loading 중 -->
        <v-skeleton-loader
          v-if="isShowSuccess && isLoading"
          dark
          class="mx-auto my-3"
          max-height="120"
          type="image"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="isShowSuccess && isLoading"
          dark
          class="mx-auto my-3"
          max-height="120"
          type="image"
        ></v-skeleton-loader>

        <!-- Summary 변환 성공 후 화면 -->
        <v-row class="mx-6" v-if="isEmptySummary" dense no-gutters>
          <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
            {{ $t('summaryFailContent') }}
          </v-col>
        </v-row>
        <v-row
          class="mx-6"
          v-if="(summarySegments === undefined || summarySegments === null) && !isLoading && !isEmptySummary"
        >
          <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
            {{ $t('noSegments') }}
          </v-col>
        </v-row>
      </div>
    </div>

    <v-card
      v-else-if="reRender"
      v-for="(item, index) in filteredItem"
      :ref="`summaryCard-${item.topic}`"
      class="wrap-summary-card my-3"
      elevation="0"
      :key="index"
      color="#31434f"
      flat
      dark
      @click="onClickSummaryCard(item)"
      @touchend="onClickSummaryCard(item)"
      :class="{ summaryCardClicked: clickedSummaryCardComparison(item) }"
      :ripple="false"
    >
      <v-row dense no-gutters align="center">
        <v-col>
          <v-textarea
            v-if="editIndex != null && editIndex === index"
            class="edit-title summary-title"
            dark
            solo
            dense
            rows="1"
            auto-grow
            hide-details
            v-model="item.topic"
            :value="item.topic"
          ></v-textarea>
          <v-card-title v-else class="summary-title">{{ item.topic }}</v-card-title>
        </v-col>
        <v-col cols="auto" class="summary-col-btn">
          <div
            v-if="!(editIndex != null && editIndex === index)"
            v-show="item.summaryMenu"
            no-gutters
            align="end"
            class="dot-comment flex-column"
          >
            <v-menu v-model="item.summaryMenu" offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn plain v-bind="attrs" v-on="on" class="dot-menu mr-2">
                  <span
                    style="font-size: 16px; font-weight: 500"
                    class="material-icons-round white--text"
                    translate="no"
                  >
                    {{ item.summaryMenu ? 'close' : 'more_horiz' }}
                  </span>
                </v-btn>
              </template>
              <div class="container-menu-summary">
                <v-row align="center" justify="center" dense>
                  <v-col v-if="isClOrganizer" cols="12">
                    <v-btn
                      dark
                      block
                      class=""
                      color="#eee"
                      plain
                      @click="editGoal(item, index), (item.summaryMenu = false)"
                    >
                      <span class="material-icons-round mr-1 btn-span" translate="no">edit</span>
                      {{ $t('edit') }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn dark block class="" color="#eee" plain @click="copy(item)">
                      <span class="material-icons-round mr-1 btn-span" translate="no">copy</span>
                      {{ $t('copy') }}
                    </v-btn>
                  </v-col>
                  <v-col v-if="isClOrganizer || isMtOrganizer || isWsOwner || isWsManager" cols="12" style="padding: 0">
                    <v-divider dark style="display: block"></v-divider>
                  </v-col>
                  <v-col v-if="isClOrganizer || isMtOrganizer || isWsOwner || isWsManager" cols="12">
                    <v-btn
                      @click="deleteSummary(index)"
                      :loading="isDeleteLoading"
                      dark
                      block
                      class=""
                      color="#eee"
                      plain
                    >
                      <span class="material-icons-round mr-1 btn-span" translate="no">delete</span>
                      {{ $t('delete') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-menu>
          </div>
        </v-col>
      </v-row>

      <v-card-subtitle
        :class="
          editIndex != null && editIndex === index
            ? 'summary-subtitle summary-content'
            : 'summary-subtitle summary-content mb-3'
        "
      >
        <v-textarea
          v-if="editIndex != null && editIndex === index"
          class="edit-content mr-1 mb-2"
          dark
          solo
          dense
          rows="1"
          auto-grow
          hide-details
          v-model="item.summary"
          :value="item.summary"
          autofocus
        ></v-textarea>
        <div v-else v-html="highlighted(item.summary.replace(/(?:\r\n|\r|\n)/g, '<br />'))"></div>
      </v-card-subtitle>

      <v-card-actions
        v-if="item.timestamps"
        :class="editIndex != null && editIndex === index ? 'wrap-timestamp' : 'wrap-timestamp mb-3'"
      >
        <div v-if="editIndex != null && editIndex === index">
          <v-textarea
            v-for="(items, index) in item.timestamps"
            :key="index"
            class="edit-timestamp ml-1"
            dark
            solo
            dense
            single-line
            hide-details
            :v-model="getStartTime(item.timestamps[index])"
            :value="convertSecondsToTime(items)"
            @keydown.enter.prevent="convertInputToTime($event.target.value)"
            @blur="convertInputToTime($event.target.value)"
            @keypress="isNumber($event)"
          ></v-textarea>
        </div>
        <div v-else>
          <v-btn
            v-for="items in item.timestamps"
            :key="items"
            class="ml-1 mb-1"
            color="#1a272e"
            elevation="0"
            :style="{
              color:
                items === clickedSummaryTimestamp && clickedSummaryCard && clickedSummaryCard.sgId === item.sgId
                  ? '#ff575f'
                  : '',
            }"
            @click.stop="onClickSummaryCardTimestamp(items, item)"
          >
            {{ convertSecondsToTime(items) }}
          </v-btn>
        </div>
      </v-card-actions>

      <v-col cols="12" v-if="editIndex != null && editIndex === index" class="wrap-edit-menu pr-4" align="end">
        <v-btn
          dark
          class=""
          color="#eee"
          plain
          @click.stop="
            submitEditGoal(index, false),
              (item.summaryMenu = false),
              (item.summary = oldValue.summary),
              (item.topic = oldValue.topic)
          "
        >
          <span class="material-icons-round mr-1 btn-span" translate="no">cancel</span>
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          dark
          class="btn-save"
          color="#eee"
          plain
          :loading="isEditLoading"
          @click.stop="submitEditGoal(index, true), (item.summaryMenu = false)"
        >
          <span class="material-icons-round mr-1 btn-span" translate="no">save</span>
          {{ $t('save') }}
        </v-btn>
      </v-col>
    </v-card>
    <summary-regeneration
      v-if="isSummaryRegenerationDialog"
      @close="closeDialog"
      @submitTemplate="submitTemplate"
      @submitTopic="submitTopic"
      :isSummaryRegenerationDialog.sync="isSummaryRegenerationDialog"
      :btnSelectLanguage="true"
    ></summary-regeneration>
  </div>
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { isMobile } from '@/common/lib/strLib'
import { mapGetters, mapState, mapActions } from 'vuex'
import { updateSummaryInfo, createSummarySegment } from '@/services/clipApi'
import SummaryRegeneration from '@/views/modal/SummaryRegeneration'
import SelectLanguage from '@/views/modal/SelectLanguage'

export default {
  name: 'DetailSummary',
  components: { SummaryRegeneration, SelectLanguage },
  props: [],
  created() {
    // console.log(this)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyEvent)
  },
  async mounted() {
    this.resetSummary()
    await this.getSummaryInfo()
    document.addEventListener('keydown', this.keyEvent)
  },
  updated() {},
  unmounted() {},
  data() {
    return {
      // clickedSummaryCard: null,
      searchOn: false,
      search: '',
      searchItem: [],
      summaryMenu: false,
      editIndex: null,
      isEditLoading: false,
      isDeleteLoading: false,
      isCreateSummaryLoading: false,
      isEditing: false,

      oldValue: {
        topic: '',
        summary: '',
      },
      editedTimeStamp: '',
      editedAddTimestamp: '',

      // Skeleton Loading
      isLoading: true,
      // 데이터는 가져왔지면 array length 가 0 인 경우
      isEmptySummary: false,

      isSummaryRegenerationDialog: false,
      template: null,
      isAdd: false,
      topic: '',
      summary: '',
      summarySegmentsKey: 0,
      reRender: true,
    }
  },
  methods: {
    ...mapActions([
      'setSummary',
      'setClickedSummaryCard',
      'setIsClickedSummaryTimestamp',
      'setClickedSummaryTimestamp',
      'setIsSummaryPlayOn',
      'setTimeStampSeekTime',
      'setIsRequestSetSeekTime',
      'setSummarySegments',
      'setSummaryInfo',
      'setSummaryTimeout',
      'setTranslateSummary',
      'setTotalSectionList',
      'setCurrentClip',
    ]),
    keyEvent(e) {
      if (e.keyCode == 13 && e.target.id === 'addTitle') {
        e.preventDefault()
        this.$refs.addContent.$refs.input.focus()
      } else if (e.keyCode == 8 && e.target.id === 'addContent' && e.target.value === '') {
        e.preventDefault()
        this.$refs.addTitle.$refs.input.focus()
      }
    },
    async setTranslate(language) {
      try {
        this.$store.dispatch('setSummarySegments', null)
        this.totalSectionList[this.sectionIndex].clipList[this.clipIndex]['summaryStatus'] = 0
        this.currentClip['summaryStatus'] = 0
        this.setTotalSectionList(this.totalSectionList)
        this.setCurrentClip(this.currentClip)

        this.setTranslateSummary({
          smId: this.summaryInfo['smId'],
          smLanguage: language,
        })
      } catch (error) {
        console.log('translate summary error : ', error)
      }
    },
    // Summary 의 Segment 를 추가해준다.
    async createSummarySegment() {
      try {
        this.isCreateSummaryLoading = true
        this.convertInputToTime(this.timestamp, 'add')
        let setCreateSummaryResult = await createSummarySegment(
          this,
          this.currentClip['clipId'],
          this.topic,
          this.summary,
          this.editedAddTimestamp
        )
        console.log('setCreateSummaryResult ? ', setCreateSummaryResult)
      } catch (error) {
        console.log('create segment error : ', error)
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.summarySegmentsKey += 1
        this.isCreateSummaryLoading = false
        this.isAdd = false
        this.editedAddTimestamp = ''

        this.getSummaryInfo()
      }
    },
    changeAdd() {
      this.isAdd = !this.isAdd
      setTimeout(
        function () {
          this.$refs.addTitle.focus()
        }.bind(this),
        400
      )
    },
    openDialog(type) {
      if (type === 'SummaryRegeneration') {
        this.isSummaryRegenerationDialog = true
      }
    },
    closeDialog(type) {
      if (type === 'SummaryRegeneration') {
        this.isSummaryRegenerationDialog = false
      }
    },
    submitTemplate(template) {
      this.template = template
      // console.log(this.template)
    },
    submitTopic(topics) {
      this.topic = topics
      // console.log(this.topic)
    },
    getStartTime(item) {
      return this.convertSecondsToTime(item)
    },
    async getSummaryInfo() {
      try {
        // 변환중이거나 변환 성공했을때만 호출
        if (this.currentClip && (this.isShowLoading || this.isShowSuccess)) {
          // if (this.isShowSuccess) this.isLoading = true
          await this.$store.dispatch('getSummaryInfo', true)
        } else {
          // Todo: Clip 이 없을때 오류 표시
        }
      } catch (error) {
        console.error('summary error ', error)
      }
    },
    storeSummary(summary) {
      this.setSummary(summary)
      this.setSummarySegments(summary.smSegments)
    },
    resetSummary() {
      this.isEmptySummary = false
      this.isLoading = true
      this.setSummary(null)
      this.setSummarySegments(null)
      this.searchItem = null

      this.setSummaryInfo(null)

      // 기존에 걸려있던 5초 Timeout 해제
      if (this.summaryTimeout) {
        clearTimeout(this.summaryTimeout)
        this.setSummaryTimeout(null)
      }
    },
    onClickSummaryCardTimestamp(timestamp, card) {
      this.setIsClickedSummaryTimestamp(true)
      this.setClickedSummaryTimestamp(timestamp)
      this.setClickedSummaryCard(card)
      this.setSeekTime(timestamp)
    },
    onClickSummaryCard(item) {
      this.setClickedSummaryCard(item)
      if (item.timestamps && Array.isArray(item.timestamps)) {
        this.setSeekTime(item.timestamps[0])
        this.setClickedSummaryTimestamp(item.timestamps[0])
      }
    },
    setSeekTime(time) {
      if (this.isEditing) {
        return
      } else {
        if (time > 0) {
          this.setTimeStampSeekTime(time)
          this.setIsRequestSetSeekTime(true)
        } else {
          this.setTimeStampSeekTime(0.062 / 1000)
          this.setIsRequestSetSeekTime(true)
        }
      }
    },
    //클릭 된 카드 스크롤 해주는 함수
    scrollFocusedCard(refName, id, behavior) {
      if (this.isMobile) return

      // Check if the given reference name exists
      const ref = this.$refs[`${refName}-${id}`]
      if (!ref) return

      // Get the first element matching the reference name
      const el = ref[0].$el

      if (el && el !== null && el !== undefined) {
        el.scrollIntoView({ behavior, block: 'center' })
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 58) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    convertSecondsToTime(time) {
      var hours = Math.floor(Number(time) / 3600)
      var minutes = Math.floor((Number(time) - hours * 3600) / 60)
      var seconds = Math.floor(Number(time) - hours * 3600 - minutes * 60)

      // 1시간 이상일 때
      if (hours > 0) {
        return (
          (hours < 10 ? '0' + hours : hours) +
          ':' +
          (minutes < 10 ? '0' + minutes : minutes) +
          ':' +
          (seconds < 10 ? '0' + seconds : seconds)
        )
      }
      // 1시간 미만일 때
      else {
        return (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      }
    },
    convertInputToTime(input, add) {
      let inputStr = input.replace(/:/g, '')

      if (inputStr.length > 6) {
        inputStr = inputStr.substring(inputStr.length - 6)
      }

      let time = inputStr.padStart(6, '0')
      time = time.replace(/(\d{2})(\d{2})(\d{2})/, '$1:$2:$3')

      const clipduration = Math.floor(this.currentClip.clipDuration)
      const durationInSeconds = Math.min(
        parseInt(time.slice(0, 2)) * 3600 + parseInt(time.slice(3, 5)) * 60 + parseInt(time.slice(6, 8)),
        clipduration
      )

      if (add === 'add') {
        this.editedAddTimestamp = Number(durationInSeconds)
      } else {
        this.editedTimeStamp = Number(durationInSeconds)
      }
    },
    editGoal(item, index) {
      this.oldValue.summary = item.summary
      this.oldValue.topic = item.topic
      this.editIndex = index
      this.isEditing = true
    },
    async submitEditGoal(index, isEdit) {
      this.isEditing = false
      // 수정일 경우
      if (isEdit) {
        try {
          this.isEditLoading = true
          let item = this.summarySegments[index]
          // Todo 로 변경 가능성 있음
          let timestampIndex = 0

          // item.timestamps[timestampIndex] = this.editedTimeStamp

          if (this.editedTimeStamp !== '') {
            this.$set(item.timestamps, timestampIndex, this.editedTimeStamp)
          }

          await updateSummaryInfo(
            this,
            this.summaryInfo['clipId'],
            this.summaryInfo['smId'],
            item['sgId'],
            item['topic'],
            item['summary'],
            timestampIndex,
            item['timestamps'][timestampIndex]
          )
        } catch (error) {
          console.log('update summary error : ', error)

          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.error'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } finally {
          this.isEditLoading = false
        }
      }
      this.editIndex = null
    },
    async deleteSummary(index) {
      try {
        this.isDeleteLoading = true
        await updateSummaryInfo(
          this,
          this.summaryInfo['clipId'],
          this.summaryInfo['smId'],
          this.summarySegments[index]['sgId']
        )

        let sgIndex = this.summaryInfo['smSegments'].findIndex(
          (segment) => segment['sgId'] === this.summarySegments[index]['sgId']
        )
        if (sgIndex > -1) {
          if (this.summaryInfo['smSegments'].length > 1) this.summaryInfo['smSegments'].splice(sgIndex, 1)
          else this.summaryInfo['smSegments'] = null
        }
        this.storeSummary(this.summaryInfo)
      } catch (error) {
        console.log('delete summary error : ', error)

        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.isDeleteLoading = false
      }
    },
    highlighted(txt) {
      if (this.search) {
        let search = this.search
        let regex = new RegExp(search, 'ig')
        let result = txt.replace(regex, '<b class="searched-text">$&</b>')
        return result
      } else {
        return txt
      }
    },
    copy(item) {
      // const content = `${item.topic}\n${item.summary}\n${this.convertSecondsToTime(
      //   item.timestamps[0]
      // )} ~ ${this.convertSecondsToTime(item.timestamps[item.timestamps.length - 1])}`
      const content = `${item.topic}\n${item.summary}\n${this.convertSecondsToTime(item.timestamps[0])}`
      navigator.clipboard.writeText(content).then(() => {
        // notify(this, 'Success', this.$t('copiedClipboardText'), 'success')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('copiedClipboardText'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
      })
    },
    allCopy() {
      let content = ''
      content += '## Video Link\n'
      content += `${window.location.href}\n\n`
      for (let i = 0; i < this.summaryInfo.smSegments.length; i++) {
        if (i == this.summaryInfo.smSegments.length - 1) {
          content += `${'## ' + this.summaryInfo.smSegments[i].topic}\n${this.summaryInfo.smSegments[i].summary}`
        } else {
          content += `${'## ' + this.summaryInfo.smSegments[i].topic}\n${this.summaryInfo.smSegments[i].summary}\n\n`
        }
      }
      navigator.clipboard.writeText(content).then(() => {
        // notify(this, 'Success', this.$t('copiedClipboardText'), 'success')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('copiedClipboardText'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
      })
    },
  },
  computed: {
    summaryStatus() {
      return this.currentClip['summaryStatus']
    },
    // 변환 중, 변환 성공 시에는 Loading 을 보여줄지 체크
    isShowLoading() {
      return this.summaryStatus !== undefined && this.summaryStatus !== null && this.summaryStatus === 0
    },
    // 변환 성공
    isShowSuccess() {
      return this.summaryStatus !== undefined && this.summaryStatus !== null && this.summaryStatus === 1
    },
    // 변환 실패
    isShowFail() {
      return this.summaryStatus !== undefined && this.summaryStatus !== null && this.summaryStatus === 2
    },
    // 사용자가 체크를 통해 선택하지 않거나 영상이 짧아서 표시 되지 않는 경우
    isUncheckedOrTooShort() {
      return this.summaryStatus !== undefined && this.summaryStatus !== null && this.summaryStatus === 3
    },
    clickedSummaryCardComparison() {
      return (item) => {
        if (this.clickedSummaryCard) {
          return item.sgId === this.clickedSummaryCard.sgId
        }
        return false
      }
    },

    filteredItem() {
      if (this.search) {
        return this.summarySegments.filter((item) => {
          return item.summary.toLowerCase().match(this.search.toLowerCase())
        })
      } else {
        return this.summarySegments
      }
    },
    ...mapGetters([
      'isMtOrganizer',
      'isWsOwner',
      'isWsManager',
      'commentList',
      'sectionIndex',
      'seekTime',
      'seekTimeDecimal',
      'clipIndex',
      'clipList',
      'chkMtPublic',
      'totalSectionList',
      'controlbarIconList',
      'currentClip',
      'currentMt',
      'boxDrawn',
      'selectedCh',
      'isPauseIcon',
      'clickedSummaryCard',
      'isSummaryPlayOn',
      'summaryInfo',
      'summaryTimeout',
      'clickedSummaryTimestamp',
      'isClickedSummaryTimestamp',
      'summarySegments',
      'wsClipCnt',
    ]),

    ...mapState({
      userInfo: (state) => {
        return state.auth.userInfo
      },
      isPlayerPause: (state) => {
        return state.clip.isPlayerPause
      },
      // 재생중인 Video의  현재 Seek Time
      seekTime: (state) => {
        return state.clip.seekTime
      },
    }),
    computedWsClipCnt() {
      return this.wsClipCnt ?? {}
    },
    detailCommentInputComponent() {
      return this.$root.$refs[`DetailCommentInput-${this.sectionIndex}`]
    },
    boxCommentComponent() {
      return this.$root.$refs[`BoxComment-${this.sectionIndex}`]
    },
    commentPlayComponent() {
      return this.$root.$refs[`CommentPlay-${this.sectionIndex}`]
    },
    currentUser() {
      let user = this.$store.getters.userInfo
      return user && user !== null ? user : {}
    },
    isSectionMt() {
      return this.currentMt.sectionInfo && this.currentMt.sectionInfo !== null && this.currentMt.sectionInfo.length > 0
    },
    isMobile() {
      return isMobile()
    },
    isLastClip() {
      return (
        this.clipList &&
        this.clipList !== null &&
        this.clipList.length > 0 &&
        this.$store.getters.isLastClip &&
        this.$store.getters.isLastClip !== null
      )
    },
    isFeedback: (state) => {
      return state.clip.isFeedback
    },
    isInIframe() {
      return window.location != window.parent.location
    },
    isClOrganizer() {
      let clipUploader = this.currentClip.clipUploader
      if (clipUploader && this.userInfo) {
        return clipUploader.userId === this.userInfo.userId
      }
      return false
    },
    addTimestamp: {
      get() {
        return this.convertSecondsToTime(this.seekTime)
      },
      set(val) {
        this.timestamp = val
      },
    },
  },
  watch: {
    summaryInfo(summary) {
      let parsedSummary = summary && typeof summary === 'string' ? JSON.parse(summary) : summary
      if (parsedSummary) {
        if (parsedSummary && parsedSummary['smSegments'] && parsedSummary['smSegments'].length > 0) {
          this.storeSummary(parsedSummary)
        } else if (parsedSummary && parsedSummary['smSegments'] && parsedSummary['smSegments'].length === 0) {
          // 로딩이 다 끝났지만 데이터가 비어있는 경우 체크
          this.isEmptySummary = true
        }
        this.isLoading = false
        // this.currentClip['summaryStatus'] = 1
        if (this.summaryInfo && this.summaryInfo['smSegments'] && this.summaryInfo['smSegments'].length > 0) {
          this.summaryInfo['smSegments'].sort(function (a, b) {
            if (!b.timestamps || !a.timestamps || a.timestamps[0] < b.timestamps[0]) {
              return -1
            }
            if (a.timestamps[0] > b.timestamps[0]) {
              return 1
            }
            return 0
          })
        }
      }
    },
    currentClip() {
      // Summary 정보는 초기화
      this.resetSummary()
      this.editIndex = null
      this.isEditing = false

      // Summary 정보 호출
      this.getSummaryInfo()
    },

    isPauseIcon(bool) {
      this.setIsSummaryPlayOn(bool)
    },

    clickedSummaryCard(card) {
      if (card) {
        this.scrollFocusedCard('summaryCard', card.topic, 'smooth')
      }
    },

    search(val) {
      if (!val) {
        this.searchItem = this.summarySegments
        // this.searchItem = this.dummyData
      }
    },
    searchOn(val) {
      if (!val) {
        this.search = ''
        this.searchItem = this.summarySegments
        // this.searchItem = this.dummyData
      } else {
        setTimeout(() => document.querySelector('#summarySearchField').focus())
      }
    },
  },
}
</script>

<style scoped>
.summaryCardClicked,
.summaryCardClicked:focus-within {
  /* border: 1px solid rgb(29, 41, 47); */
  box-shadow: 0px 0px 0px 1px #ff575f !important;
}

.wrap-summary-card {
  background-color: rgb(49, 67, 79);
  overflow: hidden;
  width: calc(100% - 2px);
  margin-left: 1px;
}
.wrap-summary-card >>> .v-input__slot {
  background-color: transparent !important;
}
.wrap-summary-card >>> input,
.wrap-summary-card >>> textarea {
  font-size: 14px !important;
}
.wrap-summary-card >>> textarea {
  margin-top: 0px !important;
}
.wrap-summary-card >>> input::placeholder,
.wrap-summary-card >>> textarea::placeholder {
  color: #96a7af90 !important;
}
.add-time >>> input {
  text-align: right;
}
.summary-title {
  font-size: 14px;
  padding: 8px 16px;
}
.summary-subtitle {
  font-size: 13px;
  line-height: 160%;
  padding: 0px 16px;
}
.summary-col-btn {
  position: absolute;
  top: 8px;
  right: 15px;
  width: 36px;
  border-radius: 5px;
}
.wrap-timestamp {
  padding: 0px 16px;
  justify-content: end;
}
.wrap-timestamp button {
  height: 26px !important;
  padding: 0 8px !important;
}
.wrap-timestamp button >>> span {
  font-size: 11px !important;
  font-weight: 500;
}
.container-menu-summary {
  width: 128px;
  padding: 4px;
  border-radius: 5px;
  border: 1px solid #475e69;
  background-color: #1d292f;
  overflow: hidden;
}
.container-menu-export {
  width: 158px;
}
.container-menu-summary >>> .row--dense > .col {
  padding: 4px;
}
.top-menu-summary >>> .row--dense > .col {
  padding: 4px 0px 4px 4px !important;
}
.container-menu-summary >>> button span {
  font-size: 13px;
  font-weight: 400;
}

.container-menu-summary >>> button {
  width: 120px;
  justify-content: start;
}
.container-menu-summary >>> button:hover {
  background-color: #161d21;
}
.container-btn-edit >>> button span,
.container-btn-reply >>> button span {
  font-size: 12px;
  font-weight: 400;
}
.wrap-summary-card:hover .dot-comment {
  display: inline-flex !important;
}
.dot-comment >>> button.dot-menu {
  padding: 0;
  min-width: 36px;
  height: 36px !important;
}
.top-menu-summary >>> button span {
  font-weight: 400;
}
.top-menu-summary >>> button {
  height: 30px !important;
  background-color: #21343b;
  font-size: 13px;
  border-radius: 3px;
}
.top-menu-summary >>> button.btn-top {
  width: 100px;
}
.top-menu-summary >>> button.regeneration {
  width: 125px;
}
.top-menu-summary >>> button.close {
  width: 30px;
  height: 30px !important;
  background-color: transparent;
  border-radius: 3px;
}
.top-menu-summary >>> button.close span {
  font-size: 20px;
  font-weight: 400;
}
.top-menu-summary >>> .v-text-field {
  padding: 0;
}
.top-menu-summary >>> .v-text-field.v-text-field--solo .v-input__control {
  min-height: 32px;
}
.top-menu-summary >>> .v-text-field .v-label {
  top: 1px;
  font-size: 14px;
}
.top-menu-summary >>> .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
  background-color: #21343b;
  box-shadow: none;
}
.top-menu-summary >>> .v-text-field .v-input__prepend-inner {
  margin: 2px 0 0 0;
}
.top-menu-summary >>> .v-input__icon i {
  font-size: 20px;
}
.top-menu-summary >>> .v-input input {
  max-height: unset !important;
  padding: 0;
  font-size: 14px;
}
.btn-span {
  color: #ddd;
  font-size: 18px;
  font-weight: 400;
}
.btn-span.disabled {
  color: #777;
}
.summary-content >>> .searched-text {
  color: #ffc542 !important;
}
.wrap-edit-menu >>> button {
  height: 30px !important;
  padding: 0 12px !important;
}
.wrap-edit-menu >>> button span {
  font-size: 13px;
  font-weight: 400;
}
.wrap-add-menu >>> button {
  background-color: transparent;
  height: 30px !important;
  padding: 0 12px !important;
}
.wrap-add-menu >>> button span {
  font-size: 13px;
  font-weight: 400;
}
.edit-title {
  font-size: 14px;
  font-weight: 500;
}
.edit-content {
  font-size: 13px;
}
.edit-timestamp {
  display: inline-flex;
  font-size: 11px;
  font-weight: 500;
}
.edit-title >>> textarea,
.edit-content >>> textarea {
  line-height: unset !important;
  align-self: center;
  margin-top: 0 !important;
  letter-spacing: 0.0071428571em;
}
.edit-title >>> textarea {
  padding-top: 5px !important;
  letter-spacing: 0.0125em;
}
.edit-timestamp >>> .v-input__control {
  min-height: 27px !important;
}
.edit-timestamp >>> textarea {
  resize: none;
  min-height: 28px !important;
  overflow: hidden;
  height: 20px;
  margin-top: 0 !important;
  text-align: right;
}
.edit-title >>> .v-input__slot,
.edit-content >>> .v-input__slot {
  background-color: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
}
.edit-timestamp >>> .v-input__slot {
  background-color: rgb(26, 39, 46) !important;
  width: 80px;
  height: 25px;
  padding: 0 16px 0 0 !important;
}
.btn-save {
  border: 1px solid #475e69;
}
.loading-text-big {
  font-size: 18px;
  font-weight: 600;
  color: #96a7af;
}
.loading-text-small {
  font-size: 13px;
  color: #717e85;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.v-btn.v-btn--disabled:disabled {
  background-color: rgba(22, 29, 33, 0.4) !important;
}
</style>
